interface KeypadProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

function Keypad({ value, onChange, disabled = false }: KeypadProps) {
  const handleNumberClick = (num: string) => {
    if (disabled) return
    onChange(value + num)
  }

  const handleBackspace = () => {
    if (disabled) return
    onChange(value.slice(0, -1))
  }

  const handleClear = () => {
    if (disabled) return
    onChange('')
  }

  const buttonClass = `
    w-full h-16 lg:h-20 fhd:h-24
    text-2xl lg:text-3xl font-bold
    bg-white border border-gray-300 rounded-lg
    hover:bg-gray-50 active:bg-gray-100
    transition-all
    disabled:opacity-50 disabled:cursor-not-allowed
  `

  return (
    <div className={`bg-fx-currency-bg p-4 rounded-lg ${disabled ? 'opacity-50' : ''}`}>
      <div className="grid grid-cols-3 gap-2">
        {/* Row 1: 7 8 9 */}
        <button
          type="button"
          onClick={() => handleNumberClick('7')}
          disabled={disabled}
          className={buttonClass}
        >
          7
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('8')}
          disabled={disabled}
          className={buttonClass}
        >
          8
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('9')}
          disabled={disabled}
          className={buttonClass}
        >
          9
        </button>

        {/* Row 2: 4 5 6 */}
        <button
          type="button"
          onClick={() => handleNumberClick('4')}
          disabled={disabled}
          className={buttonClass}
        >
          4
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('5')}
          disabled={disabled}
          className={buttonClass}
        >
          5
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('6')}
          disabled={disabled}
          className={buttonClass}
        >
          6
        </button>

        {/* Row 3: 1 2 3 */}
        <button
          type="button"
          onClick={() => handleNumberClick('1')}
          disabled={disabled}
          className={buttonClass}
        >
          1
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('2')}
          disabled={disabled}
          className={buttonClass}
        >
          2
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('3')}
          disabled={disabled}
          className={buttonClass}
        >
          3
        </button>

        {/* Row 4: 0 00 ← */}
        <button
          type="button"
          onClick={() => handleNumberClick('0')}
          disabled={disabled}
          className={buttonClass}
        >
          0
        </button>
        <button
          type="button"
          onClick={() => handleNumberClick('00')}
          disabled={disabled}
          className={buttonClass}
        >
          00
        </button>
        <button
          type="button"
          onClick={handleBackspace}
          disabled={disabled}
          className={`${buttonClass} bg-gray-200 hover:bg-gray-300 active:bg-gray-400`}
        >
          ←
        </button>

        {/* Row 5: 전체지우기 (spans all 3 columns) */}
        <button
          type="button"
          onClick={handleClear}
          disabled={disabled}
          className={`
            col-span-3 h-16 lg:h-20 fhd:h-24
            text-xl lg:text-2xl font-bold
            bg-fx-reset text-white rounded-lg
            hover:opacity-90 active:opacity-80
            transition-all
            disabled:opacity-50 disabled:cursor-not-allowed
          `}
        >
          전체지우기
        </button>
      </div>
    </div>
  )
}

export default Keypad
